export const API_URL = "https://api-girorganic.roomi.in";